import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Entry, JurorSelection } from '../entry';

@Component({
  selector: 'app-select-entry',
  templateUrl: './select-entry.component.html',
  styleUrls: ['./select-entry.component.less']
})
export class SelectEntryComponent {
  showRejectButton = true;

  @Input() entry: Entry;
  @Output() selectEntry: EventEmitter<JurorSelection> = new EventEmitter<JurorSelection>();

  @Input()
  set showReject(show: boolean) {
    this.showRejectButton = show;
  }

  firstHighlight(): boolean {
    return this.entry.jurorSelection === JurorSelection.FirstImage;
  }
  secondHighlight(): boolean {
    return this.entry.jurorSelection === JurorSelection.SecondImage;
  }
  neitherHighlight(): boolean {
    return this.entry.jurorSelection === JurorSelection.NeitherImage;
  }
  selectLeft(): void {
    this.selectEntry.emit(JurorSelection.FirstImage);
  }
  selectRight(): void {
    this.selectEntry.emit(JurorSelection.SecondImage);
  }
  selectNeither(): void {
    this.selectEntry.emit(JurorSelection.NeitherImage);
  }
}
